{
  "account": {
    "title": "บัญชีของฉัน",
    "list": {
      "title": "บัญชี",
      "description": "รายการใบแจ้งหนี้ของบัญชีที่เชื่อมต่อ"
    },
    "form": {
      "name": {
        "title": "ชื่อ",
        "description": "ชื่อบัญชีของคุณ"
      },
      "password": {
        "title": "รหัสผ่าน",
        "description": "ตั้งรหัสผ่านใหม่สำหรับบัญชีของคุณ, ทิ้งไว้ว่างเพื่อรักษารหัสผ่านปัจจุบัน"
      },
      "emailPreferences": {
        "title": "การตั้งค่าอีเมล",
        "description": "เลือกประเภทการแจ้งเตือนทางอีเมล"
      }
    },
    "billing": "รายละเอียดการเรียกเก็บเงิน",
    "subscriptions": "การสมัครสมาชิก",
    "manageSubscription": "จัดการการสมัครสมาชิก",
    "popup": {
      "cancel": "คุณแน่ใจหรือว่าต้องการยกเลิกการสมัครของคุณ? <br/>เว็บไซต์ของคุณจะยังคงแปลต่อจนถึงสิ้นสุดระยะเวลาการสมัครปัจจุบัน หลังจากนั้นการแปลจะถูกปิดใช้งาน.<br/>โปรดทราบว่าคุณจะไม่ได้รับเงินคืนสำหรับช่วงเวลาที่ไม่ได้ใช้.",
      "downgrade": "คุณแน่ใจหรือว่าต้องการลดระดับ? การลดระดับจะมีผลทันที.<br/>โปรดทราบว่าคุณจะไม่ได้รับเงินคืนสำหรับเวลาที่เหลือของรอบการเรียกเก็บเงินปัจจุบัน.<br/>ราคาของแผนใหม่จะใช้ในรอบการเรียกเก็บเงินถัดไป.",
      "default": "คุณแน่ใจหรือว่าต้องการเปลี่ยนแผนของคุณ?",
      "resume": "คุณแน่ใจแล้วหรือว่าต้องการต่ออายุการสมัครสมาชิก?"
    }
  },
  "ai_translation": {
    "header": "การแปล AI",
    "plan": {
      "header": "ราคาแปล AI",
      "used": "คุณได้ใช้ {words_used} / {words_allowed} คำที่แปลในเครดิต AI ของคุณแล้ว",
      "remaining": "เครดิต AI ที่มีอยู่:",
      "words": "คำ",
      "add_more_credits": "เพิ่มเครดิต AI เพิ่มเติม",
      "details": {
        "idiomatic_expressions": "สำนวนและเทคนิคพิเศษ",
        "background_translation": "การแปลในพื้นหลัง",
        "best_website": "เว็บไซต์ที่ต้องการคุณภาพการแปลที่สมบูรณ์แบบ",
        "page_context": "บริบทของหน้าและเว็บไซต์สำหรับการแปล",
        "perfect_quality": "คุณภาพสมบูรณ์แบบ, ราคาที่คุ้มค่า",
        "no_recurring": "ไม่มีการชำระเงินแบบต่อเนื่อง, โควต้าแบบจ่ายล่วงหน้า",
        "save_40": "ประหยัด 40% เทียบกับแผน $20",
        "save_50": "ประหยัด 50% เทียบกับแผน $20"
      },
      "quota": "{estimated_words} คำ ~ {estimated_pages} หน้า"
    },
    "settings": {
      "banner": {
        "title": "การแปล AI ของ Linguise",
        "intro": "Linguise ยินดีเปิดตัว Linguise AI Translation ฟีเจอร์พรีเมียมใหม่ที่ใช้โมเดล AI LLM (รุ่นล่าสุดของ Llama, ปรับให้เหมาะกับงานแปล) ออกแบบสำหรับเว็บไซต์ที่ต้องการความแม่นยำไร้ที่ติ, พิจารณาบริบทของหน้าและเว็บไซต์ทั้งหมดเพื่อผลลัพธ์ที่เหนือระดับ ให้ลูกค้าของคุณได้รับคุณภาพการแปลสูงสุด, ทำให้ข้อความของพวกเขาถูกถ่ายทอดอย่างสมบูรณ์ในทุกภาษา",
        "button": "อัปเกรดตอนนี้"
      },
      "alert": {
        "description": "ฟีเจอร์นี้ไม่รวมในแผนปัจจุบันของคุณและต้องซื้อแยกต่างหาก.\nเปิดใช้งานแอ็ดออนนี้เพื่อปลดล็อกตัวเลือกทั้งหมดด้านล่าง."
      },
      "languages": {
        "title": "ใช้การแปล AI กับภาษา",
        "description": "เลือกภาษาที่คุณต้องการให้การแปล AI ใช้งาน"
      },
      "button": {
        "save": "บันทึกการตั้งค่า"
      },
      "form": {
        "advanced": {
          "title": "คำสั่ง AI ขั้นสูง",
          "description": "คำสั่ง AI ขั้นสูง"
        },
        "enable_mode": {
          "title": "เปิดใช้งานการแปล AI",
          "description": "เลือกวิธีการเปิดใช้งานการแปล AI.\nRules only จะใช้กฎเท่านั้น.\nLive editor only จะอนุญาตให้เปิดใช้งานการแปลหน้าโดยหน้าได้จากมุมมอง Live editor.\nRules and live editor จะใช้ทั้งสองฟีเจอร์",
          "disabled": "ปิดใช้งาน",
          "rules": "ใช้กฎเท่านั้น",
          "live_editor": "Live editor เท่านั้น",
          "all": "กฎและ Live editor"
        },
        "rule_application": {
          "description": "ใช้การแปล AI กับเนื้อหาแบบคงที่หรือแบบไดนามิก หรือทั้งสองอย่าง",
          "title": "ใช้กับเนื้อหา",
          "all": "เนื้อหาทั้งหมด",
          "static": "เนื้อหาคงที่",
          "dynamic": "เนื้อหาไดนามิก"
        },
        "website_topic": {
          "title": "หัวข้อเว็บไซต์",
          "placeholder": "ร้านซูชิ...",
          "description": "กำหนดหัวข้อของเว็บไซต์เพื่อคุณภาพการแปลที่ดีขึ้น (เช่น กฎหมาย, ร้านซูชิ, ร้านอะไหล่จักรยาน…)\nกรุณากรอกหัวข้อเว็บไซต์เป็นภาษาอังกฤษ"
        },
        "apply_to_urls": {
          "title": "ใช้กับ URL",
          "description": "เลือก URL เฉพาะที่คุณต้องการให้การแปล AI ใช้งาน",
          "all_urls": "ทุก URL",
          "selected_urls": "URL ที่เลือก",
          "label": "URL ที่จะใช้",
          "placeholder": "URL ที่จะใช้",
          "wildcard": "อักขระตัวแทน",
          "regex": "นิพจน์ทั่วไป",
          "add": "เพิ่มใหม่",
          "expression": "ประเภทของนิพจน์"
        },
        "apply_languages": {
          "title": "ใช้กับภาษา",
          "description": "เลือกภาษาที่คุณต้องการให้การแปล AI ใช้งาน",
          "all_languages": "ทุกภาษา",
          "selected_languages": "ภาษาเลือก",
          "placeholder": "เลือกภาษา...",
          "feedback": "คุณต้องเลือกภาษาหนึ่งรายการ"
        },
        "formality": {
          "title": "ความเป็นทางการ",
          "description": "กำหนดระดับความเป็นทางการของการแปล, อาจสำคัญต่อผู้ชมและบริบท.\n\"Neutral\" จะพยายามรักษาระดับความเป็นทางการของต้นฉบับ.\n\"Formal\" เหมาะกับเนื้อหาแบบมืออาชีพ, ธุรกิจ หรือกฎหมาย (เช่น ใช้สรรพนามทางการในภาษาสเปน).\n\"Informal\" เหมาะกับเนื้อหาแบบสนทนา, ไม่เป็นทางการ (เช่น ใช้ \"tú\" ในภาษาสเปน).",
          "neutral": "ปกติ",
          "formal": "เป็นทางการ",
          "informal": "ไม่เป็นทางการ"
        },
        "sentence_structure": {
          "classic": "คลาสสิก",
          "short": "ประโยคสั้นและกระชับ",
          "detailed": "ประโยคละเอียดและอธิบาย",
          "title": "โครงสร้างประโยค",
          "description": "กำหนดสไตล์การเขียนที่ต้องการ"
        },
        "content_purpose": {
          "marketing": "การตลาด/โปรโมชั่น (โน้มน้าว, โทนที่ดึงดูด)",
          "technical": "เทคนิค/สอน (ชัดเจน, แม่นยำ, เน้นการทำ)",
          "support": "การสนับสนุนลูกค้า (เอาใจใส่, ช่วยเหลือ, ให้ความมั่นใจ)",
          "legal": "กฎหมาย/การปฏิบัติตาม (แม่นยำ, เป็นทางการ, ไม่คลุมเครือ)",
          "educational": "การศึกษา (ชัดเจน, มีโครงสร้าง, เข้าถึงง่าย)",
          "other": "อื่น ๆ (เป็นภาษาอังกฤษ)",
          "title": "วัตถุประสงค์ของเนื้อหา",
          "description": "กำหนดวัตถุประสงค์การใช้งานของเนื้อหาที่จะแปล",
          "other_placeholder": "อธิบายวัตถุประสงค์..."
        },
        "target_audience": {
          "title": "กลุ่มเป้าหมาย",
          "description": "ระบุกลุ่มเป้าหมายของเนื้อหาที่แปล (เป็นภาษาอังกฤษ)",
          "placeholder": "เช่น ผู้ปกครองที่พูดภาษาสเปน เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของสหภาพยุโรป"
        },
        "override_default_translations": {
          "title": "เขียนทับการแปลค่าเริ่มต้น",
          "description": "หากตั้งค่าเป็น YES ตัวเลือกนี้จะบังคับให้เนื้อหาแปลด้วย AI (Linguise AI) แม้ว่าจะถูกแปลแล้วด้วย Cloud AI translation (โมเดลแปลค่าเริ่มต้น)"
        },
        "force_replace_before": {
          "title": "บังคับแปลซ้ำด้วย AI",
          "description": "แปลเนื้อหาที่แปลด้วย AI ก่อนวันที่เลือกซ้ำด้วย AI เช่น เนื้อหาที่แปลด้วยโมเดลรุ่นเก่า การแปลซ้ำจะเกิดขึ้นเมื่อมีผู้เข้าชมหน้าที่ใช้กฎอีกครั้ง และใช้เครดิต AI ของคุณ",
          "before_date": "ก่อนวันที่"
        },
        "model": {
          "current": "ปัจจุบัน",
          "title": "โมเดล",
          "description": "เลือกโมเดลการแปลภาษา LLM ที่คุณต้องการใช้",
          "load_error": "ไม่สามารถโหลดโมเดลที่มีอยู่ได้ กรุณาลองใหม่อีกครั้งในภายหลัง",
          "thinking_warning": "โมเดลนี้ใช้การใช้เหตุผลในระดับสูง (\"การคิด\") และจะใช้โทเค็นมากขึ้นอย่างมีนัยสำคัญต่อการแปล"
        },
        "override_manual_and_selected": {
          "no_default": "ไม่ (ค่าเริ่มต้น)",
          "title": "แทนที่การแปลด้วยตนเองและการแปลที่เลือก",
          "description": "โดยค่าเริ่มต้น การแปลที่คุณแก้ไขด้วยตนเองจะแสดงบนเว็บไซต์ของคุณเสมอ แม้จะมีการสร้างการแปลที่ปรับปรุงด้วย AI แล้วก็ตาม ตั้งค่าเป็น ใช่ เพื่อแสดงการแปลที่ปรับปรุงด้วย AI แทน การแปลด้วยตนเองของคุณจะยังคงอยู่ และคุณสามารถสลับกลับได้ทุกเมื่อ การตั้งค่านี้ยังมีผลเมื่อคุณแปลหน้าเว็บอีกครั้งเพื่อรับการแปลใหม่ โดยระบบจะใช้การแปลล่าสุดโดยอัตโนมัติ"
        }
      },
      "message": {
        "save_success": "จากเนื้อหาที่แปลแล้วในปัจจุบัน จำนวนหน้าที่จะได้รับการปรับปรุงด้วยการแปล AI อยู่ที่ประมาณ {{ai_affected_urls}}",
        "save_success_only": "บันทึกการตั้งค่าเรียบร้อยแล้ว"
      }
    },
    "pricing": {
      "plan": {
        "title": "สั่งซื้อโควต้าการแปล AI",
        "buy_button": "ซื้อแพคเกจการแปล AI"
      },
      "modal": {
        "title": "ยืนยันการเปลี่ยนแผน",
        "description": "คุณแน่ใจหรือว่าต้องการเปลี่ยนแผนการแปล AI ของคุณ?",
        "button_cancel": "ยกเลิก",
        "button_confirm": "ยืนยัน",
        "loading": "กรุณารอสักครู่...",
        "amount": "จำนวนเงิน",
        "credit": "เครดิต",
        "total_due": "ยอดที่ต้องชำระ"
      },
      "comparison": {
        "title": "การแปลด้วย AI ของ Google Cloud\nเทียบกับการแปลด้วย AI ของ Linguise",
        "list": {
          "0": {
            "google": "การแปลที่เร็วและเชื่อถือได้",
            "linguise": "จัดการกับสำนวนและเทคนิคเฉพาะ"
          },
          "1": {
            "google": "การแปลทันทีของทุกหน้าของเว็บไซต์",
            "linguise": "การสร้างการแปลในพื้นหลัง"
          },
          "2": {
            "google": "คุณภาพยอดเยี่ยม ราคาต่ำ",
            "linguise": "คุณภาพสมบูรณ์ ราคาเข้าถึงได้"
          },
          "3": {
            "google": "เหมาะที่สุดสำหรับเว็บไซต์ขนาดใหญ่หรืองบประมาณต่ำ",
            "linguise": "เหมาะสำหรับเว็บไซต์ที่ต้องการคุณภาพการแปลที่สมบูรณ์"
          },
          "4": {
            "google": "บริบทของหน้าในการแปล",
            "linguise": "บริบทของหน้าและเว็บไซต์ในการแปล"
          }
        }
      },
      "botom_banner": {
        "title": "สัมผัสความแม่นยำของการแปลที่เหนือระดับด้วย",
        "sub_title": "Linguise AI Translation ใหม่",
        "description": "Linguise กำลังเสริมบริการการแปลอัตโนมัติด้วยการเปิดตัว Linguise AI Translation ตัวเลือกใหม่ที่ทรงพลังซึ่งใช้โมเดล LLM การแปล AI ล้ำสมัย (โมเดล Llama ล่าสุดที่ปรับให้เหมาะกับการแปล) การเพิ่มนี้มอบคุณภาพการแปลระดับสูงสุดให้กับนักพัฒนาเว็บไซต์และเอเจนซี่เว็บ ซึ่งเหมาะสำหรับโครงการที่ต้องการความสมบูรณ์แบบ Linguise AI Translation เสริมกับการแปล Google Cloud AI ที่มีคุณภาพสูงเดิมของเรา ให้ความยืดหยุ่นและความแม่นยำมากยิ่งขึ้น"
      }
    },
    "success": {
      "tab_title": "ขอบคุณที่ซื้อแผน AI Translation!",
      "title": "ขอบคุณที่ซื้อแผน AI Translation!",
      "subtitle": "แผน AI Translation ของคุณได้ถูกซื้อสำเร็จแล้ว!",
      "message": "คุณสามารถจัดการแผน AI Translation ของคุณได้ในหน้าการตั้งค่า AI Translation",
      "home": "จัดการ AI Translation"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "ชื่อ",
        "description": "ชื่อบัญชีการเรียกเก็บ"
      },
      "phone": {
        "title": "โทรศัพท์",
        "description": "หมายเลขโทรศัพท์บัญชีการเรียกเก็บ"
      },
      "email": {
        "title": "อีเมล",
        "description": "อีเมลบัญชีการเรียกเก็บ"
      },
      "address": {
        "title": "ที่อยู่",
        "description": "ที่อยู่บัญชีการเรียกเก็บ",
        "city": "เมือง",
        "country": "ประเทศ",
        "address1": "ที่อยู่ 1",
        "address2": "ที่อยู่ 2",
        "postal": "รหัสไปรษณีย์",
        "state": "รัฐ"
      },
      "tax": {
        "title": "เลขประจำตัวผู้เสียภาษี"
      }
    }
  },
  "checkouts": {
    "header": "ชำระเงิน",
    "payment_method": "เลือกวิธีการชำระเงิน",
    "stripe_card": "บัตรเครดิต (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "ใส่ที่อยู่การเรียกเก็บใหม่",
      "existing": "ใช้ที่อยู่ที่มีอยู่"
    },
    "pay_stripe": "ยืนยันและชำระเงิน",
    "terms": "โดยการยืนยันการสมัครสมาชิกของคุณ คุณยอมให้ Linguise เรียกเก็บเงินจากคุณในครั้งถัดไปตามเงื่อนไขของเรา คุณสามารถยกเลิกการสมัครได้ตลอดเวลา",
    "coupon": {
      "title": "มีคูปองหรือไม่?",
      "placeholder": "ใส่โค้ดคูปองของคุณที่นี่",
      "apply": "ใช้",
      "percent": "{{0}}% ลด"
    },
    "add_new": "เพิ่มใหม่",
    "use_existing": "ใช้วิธีการชำระเงินที่มีอยู่",
    "recurring": {
      "month_single": "เรียกเก็บรายเดือน",
      "month_many": "เรียกเก็บทุก {{count}} เดือน",
      "year_single": "เรียกเก็บรายปี",
      "year_many": "เรียกเก็บทุก {{count}} ปี",
      "day_single": "เรียกเก็บรายวัน",
      "day_many": "เรียกเก็บทุก {{count}} วัน",
      "week_single": "เรียกเก็บรายสัปดาห์",
      "week_many": "เรียกเก็บทุก {{count}} สัปดาห์"
    },
    "add_new_no_stripe": "เพิ่มบัตรใหม่",
    "summary": {
      "title": "สรุป",
      "subtotal": "ยอดรวมย่อย",
      "total": "ยอดรวม"
    }
  },
  "dashboard": {
    "main": {
      "title": "แดชบอร์ด"
    },
    "statistics": {
      "main_title": "สถิติ 30 วันล่าสุด",
      "characters": "อักขระที่แปล",
      "words": "คำที่แปล",
      "bandwidth": "แบนด์วิดท์อินพุต",
      "request": "คำขอ",
      "page_views": "จำนวนการเข้าชมหน้าแต่ละภาษา (30 วันล่าสุด)",
      "multilingual_views": "จำนวนการเข้าชมหลายภาษา (30 วันล่าสุด)",
      "most_page_viewed": "20 หน้าเยี่ยมชมสูงสุด (30 วันล่าสุด)",
      "no_data_yet": "ยังไม่มีข้อมูล",
      "th_language": "ภาษา",
      "th_page_views": "จำนวนการเข้าชม",
      "real_visitors": "ผู้เข้าชมจริง",
      "crawler": "โปรแกรมรวบรวมข้อมูลเว็บ"
    },
    "planHints": {
      "subscribeButton": "สมัครสมาชิก",
      "upgradeButton": "อัปเกรด",
      "usedWords": "คุณกำลังใช้คำ {words_used}",
      "noPlan": "ไม่มีแผนที่เปิดใช้งานสำหรับโดเมนนี้. สมัครแผนและเริ่มแปลเว็บไซต์ของคุณ",
      "noPlanShopify": "ไม่มีแผนที่เปิดใช้งานสำหรับโดเมนนี้. สมัครแผนในแดชบอร์ด Shopify ของคุณและเริ่มแปลเว็บไซต์ของคุณ",
      "trialUsage": "คุณกำลังใช้คำ {words_used} จาก {words_allowed} คำที่รวมในแผนทดลอง",
      "trialEnds": "การทดลอง 1 เดือนจะเปิดใช้งานจนถึง {trial_ends}",
      "subscribeMessage": "สมัครก่อนที่ช่วงทดลองจะสิ้นสุดเพื่อให้เว็บไซต์ของคุณยังคงแปลอยู่",
      "subscribeMessageShopify": "สมัครจากแดชบอร์ด Shopify ของคุณก่อนที่ช่วงทดลองจะสิ้นสุดเพื่อให้เว็บไซต์ของคุณยังคงแปลอยู่",
      "trialReachedLimit": "คุณได้ใช้จำนวนคำแปลสูงสุดสำหรับช่วงทดลองแล้ว\nสมัครแผนของเราเพื่อดำเนินการแปลต่อ",
      "paidUsage": "คุณได้ใช้คำแปล {words_used} / {words_allowed} ในแผนของคุณ",
      "paidReachedLimit": "คุณได้ใช้จำนวนคำแปลสูงสุดสำหรับแผนปัจจุบันแล้ว\nอัปเกรดแผนของคุณเพื่อดำเนินการแปลต่อ",
      "trialOfferedUsage": "คุณกำลังใช้คำ {words_used} จาก {words_allowed} คำที่รวมในแผนทดลอง (รวมถึงคำฟรี {free_words})",
      "paidOfferedUsage": "คุณได้ใช้คำแปล {words_used} / {words_allowed} ในแผนของคุณ (รวมถึงคำฟรี {free_words})",
      "noPlanExtra": "โปรดทราบว่าโดเมนที่ไม่ได้ใช้งานและข้อมูลของมันจะถูกลบโดยอัตโนมัติเป็นระยะ",
      "planRecommended": "ตามปริมาณการแปลของคุณ แผนที่แนะนำคือ:",
      "planMaximumWords": "{{words}} คำ",
      "notHaveTranslatedWords": "คุณยังไม่ได้ทำการแปลใด ๆ"
    },
    "translationSetup": {
      "kicker": "การตั้งค่า SUBDOMAIN",
      "title": "ตรวจสอบการตั้งค่าการแปล",
      "description": "ตรวจสอบ DNS โฮสต์ที่แปลแล้ว การเข้าถึงเว็บไซต์ต้นฉบับ และขีดจำกัดบัญชี",
      "starting": "กำลังตรวจสอบ...",
      "button": "ตรวจสอบการตั้งค่า",
      "viewLatest": "ดูผลลัพธ์ล่าสุด",
      "viewCurrent": "ดูการตรวจสอบปัจจุบัน",
      "runAgain": "ตรวจสอบอีกครั้ง",
      "viewDetails": "ดูรายละเอียด",
      "hideDetails": "ซ่อนรายละเอียด",
      "error": "ไม่สามารถตรวจสอบการตั้งค่าได้",
      "allPassed": "ผ่านการตรวจสอบทั้งหมด",
      "setupNeedsAttention": "การตั้งค่าต้องได้รับการแก้ไข",
      "setupNeedsAttentionDescription": "การตรวจสอบอย่างน้อยหนึ่งรายการล้มเหลว ตรวจสอบรายการด้านล่างหรือติดต่อฝ่ายสนับสนุน Linguise",
      "lastChecked": "ตรวจสอบล่าสุด {{time}}",
      "domainOwnership": "ความเป็นเจ้าของโดเมน",
      "domainOwnershipDescription": "พบระเบียนยืนยัน",
      "domainOwnershipFailure": "ไม่สามารถยืนยันระเบียน DNS ความเป็นเจ้าของได้",
      "translatedHosts": "โฮสต์ที่แปลแล้ว",
      "translatedHostsDescription": "ตรวจสอบโฮสต์ภาษา {{count}} รายการ",
      "translatedHostsFailure": "ระเบียน CNAME ของภาษาอย่างน้อยหนึ่งรายการไม่ถูกต้อง",
      "subdomainPage": "หน้า Subdomain",
      "subdomainPageDescription": "หน้าที่แปลแล้ว {{count}} หน้ายอมรับ HTTPS",
      "subdomainPageFailure": "การเชื่อมต่อ TLS ล้มเหลวขณะเปิดหน้าที่แปลแล้วอย่างน้อยหนึ่งหน้า",
      "originalSite": "เว็บไซต์ต้นฉบับ",
      "originalSiteDescription": "การตรวจสอบ DNS, TLS และการตอบกลับของเว็บไซต์ต้นฉบับ",
      "originalSiteFailure": "การตรวจสอบ DNS, TLS หรือการตอบกลับของเว็บไซต์ต้นฉบับล้มเหลว",
      "documentationAdvice": {
        "dns": "ตรวจสอบการตั้งค่า DNS",
        "tls": "ตรวจสอบการตั้งค่า HTTPS",
        "origin": "ตรวจสอบการตั้งค่าเว็บไซต์ต้นฉบับ",
        "diagnostic": "ดูขั้นตอนการแก้ไขปัญหา"
      },
      "evidence": {
        "originDns": "DNS ต้นฉบับ",
        "originTls": "TLS ต้นฉบับ",
        "originHttp": "การตอบกลับต้นฉบับ",
        "observedTargets": "เป้าหมายที่ตรวจพบ",
        "recordCount": "พบระเบียน",
        "addressCount": "พบที่อยู่",
        "statusCode": "สถานะ HTTP",
        "redirect": "การเปลี่ยนเส้นทาง",
        "expiresAt": "ใบรับรองหมดอายุ",
        "raw": "{{key}}",
        "noValue": "ไม่มีค่า"
      },
      "checkerError": "ไม่สามารถดำเนินการตรวจสอบบางรายการให้เสร็จสิ้นได้",
      "coreLocation": "ตรวจสอบจาก {{location}}",
      "status": {
        "queued": "อยู่ในคิว",
        "running": "กำลังทำงาน",
        "completed": "เสร็จสมบูรณ์",
        "failed": "ล้มเหลว",
        "passed": "ผ่าน",
        "warning": "คำเตือน",
        "unknown": "ไม่ทราบ",
        "skipped": "ข้ามแล้ว",
        "not_applicable": "ไม่เกี่ยวข้อง"
      }
    },
    "throttling": {
      "title": "ขีดจำกัดการแปล",
      "description": "ขีดจำกัดการใช้งานชั่วคราว",
      "unavailable": "ไม่มีขีดจำกัดการแปลชั่วคราว",
      "window": "{{used}} / {{max}} คำ",
      "resetsIn": "รีเซ็ตใน {{time}}",
      "throttled": "หยุดการแปลชั่วคราว",
      "throttledDescription": "ถึงขีดจำกัดการใช้งานชั่วคราวแล้ว การแปลจะดำเนินต่อเมื่อรีเซ็ตช่วงเวลานี้"
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "ขั้นตอน {{step}} จาก {{total}}",
      "doneLabel": "เสร็จสิ้น, คุณสามารถเริ่มแปลได้!",
      "finish": {
        "title": "",
        "description": "นี่คือ API key ที่ใช้บนเว็บไซต์ของคุณ"
      },
      "instructions": "คำแนะนำการติดตั้ง",
      "domainSetting": "การตั้งค่าโดเมน",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "สคริปต์ PHP",
        "wizardWordpressStep1": "1. ติดตั้ง ",
        "wizardWordpressStep2": "\n 2. ในการตั้งค่า plugin คัดลอกและวาง API key ของคุณ\n",
        "wizardWordpressStep3": "3. คุณพร้อมที่จะแปลแล้ว\n\n",
        "wizardWordpressStep4": "สำหรับคำแนะนำโดยละเอียด โปรดดูเอกสารของเรา: ",
        "wizardJoomlaStep1": "1. ลิงก์แพ็กเกจ Joomla: ",
        "wizardJoomlaStep2": "\n2. ในการตั้งค่าการกำหนดค่าส่วนขยาย คัดลอกและกรอกคีย์ API ของคุณ",
        "wizardJoomlaStep3": "3. ในการตั้งค่ามอดูล กำหนดภาษาที่ต้องการแสดงและแทรกมอดูลของคุณในตำแหน่งที่ต้องการ",
        "wizardJoomlaStep4": "\n 4. คุณพร้อมที่จะแปลแล้ว\n\n",
        "wizardPhpStep1": "1. ดาวน์โหลดสคริปต์ php ของเราและที่นี่ ",
        "wizardPhpStep2": "\n2. ทำตามคำแนะนำการติดตั้งในหน้าตัวเอกสารของเราที่นี่ ",
        "wizardPhpStep3": "\n3. เพิ่มมอดูลไปยังหน้าของคุณ",
        "wizardPhpStep4": "\n คัดลอกโค้ดต่อไปนี้และเพิ่มลงในส่วน head ของหน้า html ของคุณ ระบบจะทำการแสดงมอดูลสวิตช์อัตโนมัติ\n",
        "dispatchStep1": "เราส่งข้อมูลที่จำเป็นไปยังปลั๊กอิน Linguise เรียบร้อยแล้ว คุณสามารถปิดหน้าต่างต่อไปนี้ได้เลย",
        "dispatchStep2": "หากโทเค็นหายไปเมื่อคุณปิดหน้าต่างนี้ โปรดคัดลอกโทเค็นต่อไปนี้:",
        "dispatchStep3": "คุณยังสามารถคัดลอกส่วนโค้ดนี้เพื่อเปิดใช้งานสวิตช์ธงของเราโดยอัตโนมัติ",
        "wizardOtherStep1": "ทำตามคำแนะนำด้านล่างเพื่อติดตั้ง Linguise บนโดเมนของคุณ.\n",
        "wizardOtherStep2": "คัดลอกโค้ดต่อไปนี้และเพิ่มลงในส่วน head ของหน้า html ของคุณ ระบบจะทำการแสดงมอดูลสวิตช์อัตโนมัติ.\n"
      },
      "trialAlreadyUsed": "ดูเหมือนว่าคุณได้ใช้การทดลองฟรีแล้ว ดังนั้นคุณต้องขอควอต้าแปล\nกรุณาสมัครแผนหรือ ติดต่อเรา หากต้องการต่ออายุการทดลอง",
      "usefulLinks": "ลิงก์ที่เป็นประโยชน์สำหรับเริ่มต้น",
      "linkDocumentation": "เอกสาร",
      "linkExtensionDl": "ดาวน์โหลดส่วนขยาย",
      "linkSubscribe": "สมัครแผนตอนนี้",
      "linkDashboard": "ไปที่แดชบอร์ด",
      "exclusion": {
        "title": "ชื่อบริษัทและผลิตภัณฑ์",
        "description": ""
      },
      "finishButton": "เสร็จสิ้นการตั้งค่า",
      "subdomains": "ซับโดเมน",
      "subdomain_setup": "ตั้งค่าโดเมน",
      "subdomain_auto_setup": "เชื่อมต่อ DNS ของคุณโดยอัตโนมัติ",
      "subdomain_manual_setup": "เพิ่มรายการ DNS ด้วยตนเอง",
      "subdomain_skip": "ทำในภายหลัง",
      "auto_subdomains_info": "CMS ตัวสร้างไซต์ของคุณต้องการการกำหนดค่า DNS เพื่อกำหนดภาษาตามซับโดเมน (เช่น es.domain.com).",
      "auto_subdomains_info_2": "คุณสามารถทำได้โดยอัตโนมัติด้วย Entri เพียงคลิกปุ่ม \"เชื่อมต่อ DNS ของคุณโดยอัตโนมัติ\" เพื่อเริ่มเชื่อมต่อกับผู้จัดการ DNS ของคุณและเพิ่มด้วย Entri.",
      "auto_subdomains_info_manual": "หรือคุณสามารถกำหนดค่าโดเมนด้วยตนเองโดยคลิกปุ่ม \"เพิ่มรายการ DNS ด้วยตนเอง\"",
      "breadcrumbs": {
        "step1": "ขั้นตอนที่ 1: โดเมน, ระบบจัดการเนื้อหา (CMS) และภาษา",
        "step2": "ขั้นตอนที่ 2: การตั้งค่า DNS ภาษา",
        "step3": "ขั้นตอนที่ {{step}}: คำแนะนำในการติดตั้ง"
      }
    },
    "form": {
      "urls": {
        "dash": "เครื่องหมายขีด -",
        "underscore": "ขีดล่าง _",
        "title": "แปล URL",
        "description": "คุณต้องการแปลในทุกหน้าใช่หรือไม่",
        "char_description": "อักขระที่ใช้แทนอักขระที่ไม่ได้รับอนุญาตใน URL",
        "advertisement_title": "⚠ คุณได้ตั้งค่าภาษาเป็นจำนวนมาก.\n",
        "advertisement": "เรามักแนะนำให้เริ่มแปลเว็บไซต์ด้วยจำนวนภาษาน้อยก่อน คุณจะได้ประมาณจำนวนคำในเว็บไซต์ของคุณ นอกจากนี้ยังดีต่อ SEO เพราะบอทของ Google จะครอว์ลหน้าเว็บของคุณได้เร็วขึ้นหากมีหน้าจำนวนไม่มาก หลังจากหนึ่งสัปดาห์คุณสามารถเพิ่มภาษาเพิ่มเติมได้ต่อไป"
      },
      "url": {
        "title": "Url",
        "description": "ใส่ URL ของโดเมนหลักของคุณโดยเริ่มด้วย http:// หรือ https://",
        "placeholder": "URL ของโดเมน",
        "advertisement_http": {
          "title": "คุณไม่ได้ใช้โปรโตคอล https",
          "description": "กรุณาตรวจสอบว่าโดเมนของคุณไม่ได้ใช้โปรโตคอล https ซึ่งเป็นมาตรฐานที่แนะนำในปัจจุบัน"
        },
        "advertisement_www": {
          "title": "ซับโดเมนของคุณไม่ใช่ www",
          "description": "ส่วนใหญ่ซับโดเมนเริ่มต้นคือ www (เช่น https://www.mydomain.com) อาจไม่ใช่กรณีของคุณ แต่กรุณาตรวจสอบให้แน่ใจว่าโดเมนที่คุณต้องการเพิ่มถูกต้อง"
        },
        "invalid_url": {
          "line1": "เราไม่สามารถค้นหาโดเมนของคุณได้ กรุณาตรวจสอบว่าโดเมนของคุณสามารถเข้าถึงได้สาธารณะผ่านอินเทอร์เน็ตและไม่ได้ถูกเปลี่ยนเส้นทางไปที่อื่น",
          "line2": "หากคุณแน่ใจว่าโดเมนเข้าถึงได้ คุณสามารถข้ามการตรวจสอบโดเมนและกดปุ่ม \"ขั้นตอนถัดไป\" อีกครั้ง",
          "contact": "ในทุกกรณีคุณสามารถติดต่อเราได้ที่",
          "force": "ข้ามการตรวจสอบโดเมน"
        },
        "invalid_subdomain_url": "URL นี้ไม่ได้รับอนุญาต โดเมนย่อยต้องอยู่ในรูปแบบ: https://www.domain.tld หรือ https://domain.tld โดยไม่มีไดเร็กทอรีย่อย"
      },
      "account": {
        "title": "บัญชี",
        "description": "เลือกบัญชีเพื่อมอบหมายโดเมนนี้",
        "placeholder": "เลือกบัญชี...",
        "feedback": "คุณต้องเลือกบัญชี"
      },
      "platform": {
        "title": "แพลตฟอร์ม",
        "description": "กรุณาเลือกแพลตฟอร์มเว็บไซต์ของคุณตามชื่อ CMS",
        "learn": "เรียนรู้วิธีเลือก",
        "placeholder": "ค้นหาแพลตฟอร์มตามชื่อ CMS...",
        "info": {
          "title": "⚠ แพลตฟอร์มนี้เพิ่งถูกเพิ่มใหม่.\n",
          "desc": "แพลตฟอร์มสร้างเว็บไซต์นี้ได้รับการสนับสนุนโดย Linguise แม้จะเพิ่งเพิ่มใหม่ หากคุณพบปัญหาใดๆ โปรดติดต่อเราผ่านอีเมลสนับสนุนโดยตรง:"
        },
        "description_read_only": "แพลตฟอร์มที่เว็บไซต์ของคุณใช้งานอยู่",
        "feedback": "คุณต้องเลือกแพลตฟอร์ม"
      },
      "language": {
        "title": "ภาษา",
        "description": "เลือกภาษาฐานของเว็บไซต์ของคุณ",
        "placeholder": "เลือกภาษา...",
        "feedback": "คุณต้องเลือกภาษา",
        "description_read_only": "ภาษาฐานของเว็บไซต์ของคุณ"
      },
      "token": {
        "title": "คีย์ API",
        "description": "นี่คือคีย์ API ที่ต้องคัดลอกไปยังเว็บไซต์ของคุณ",
        "copy": "คัดลอกไปคลิปบอร์ด",
        "reset": "รีเซ็ตคีย์ API",
        "reset_confirm": "กรุณายืนยันการรีเซ็ตคีย์ API"
      },
      "languages": {
        "title": "ภาษาที่แปล",
        "description": "เลือกภาษาที่คุณต้องการให้เว็บไซต์ของคุณแปลได้",
        "placeholder": "เลือกภาษา...",
        "feedback": "คุณต้องเลือกภาษา"
      },
      "defaultRules": {
        "title": "กฎเริ่มต้น",
        "description": "เราได้กำหนดชุดกฎที่ต้องใช้เพื่อเพิ่มประสิทธิภาพการแปลและหลีกเลี่ยงเนื้อหาที่ไม่ต้องการให้แปล เช่น แดชบอร์ดของ WordPress.\nคุณสามารถลบหรือแก้ไขกฎเหล่านี้ในภายหลังได้ตามต้องการ"
      },
      "disallow_deletion": "คุณไม่สามารถลบโดเมนที่มีการสมัครใช้บริการอยู่",
      "delete_confirm": "กรุณายืนยันการลบโดเมน",
      "delete": "ลบโดเมน",
      "dynamic": {
        "title": "แปลเนื้อหาไดนามิก",
        "description": "เนื้อหาไดนามิกที่สร้างโดย JavaScript และ AJAX จะถูกแปล (ตัวเลือกนี้จะเพิ่มการใช้โควต้าแปลของคุณ)"
      },
      "partial_translations": {
        "title": "อนุญาตการแปลบางส่วน",
        "description": "หากบัญชีของคุณถึงโควต้าแปลแล้ว แต่หน้ายังต้องการแปล Linguise สามารถแสดงหน้าด้วยเนื้อหาที่แปลแล้วต่อได้\nอย่างไรก็ตามบางส่วนของหน้าอาจยังไม่แปลจนกว่าคุณจะอัปเกรดโควต้า\n\nโดยทั่วไปเนื้อหาที่ไม่แปลจำนวนเล็กน้อยไม่ส่งผลเสียต่อ SEO มากนัก แต่หากมีเนื้อหาที่ไม่แปลมากเกินไปอาจกระทบประสบการณ์ผู้ใช้\nคุณสามารถตั้งค่าเกณฑ์เปอร์เซ็นต์เนื้อหาที่ไม่แปลที่ยอมรับได้บนหน้า หากเกินเกณฑ์ ผู้ใช้จะถูกเปลี่ยนเส้นทางอัตโนมัติไปยังหน้าภาษาเดิม",
        "never": "ไม่เลย"
      },
      "translate_error_pages": {
        "title": "แปลหน้า error",
        "description": "Linguise สามารถแปลหน้า error ทั้งหมดได้ อย่างไรก็ตามหากหน้า error ของคุณมีเนื้อหาไดนามิก เช่น ที่อยู่ IP หรือ ID ของคำขอ ควรหลีกเลี่ยงการแปลหน้าเหล่านั้น",
        "not_found_page": {
          "title": "แปลหน้า 404"
        },
        "error_page": {
          "title": "แปลหน้า error อื่น ๆ"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "พบโดเมนที่มีอยู่แล้ว",
          "description": "พบโดเมนที่มีอยู่สำหรับผู้ใช้คนนี้ คุณต้องการใช้โดเมนนั้นหรือไม่?"
        }
      },
      "search_tl": {
        "title": "ค้นหาการแปล",
        "description": "เปิดใช้งานการค้นหาการแปลสำหรับแพลตฟอร์มเว็บไซต์ของคุณ (ทดลอง, ตัวเลือกนี้จะเพิ่มการใช้โควต้าแปลของคุณ)"
      },
      "shopify_promo": {
        "info": "ข่าวดี! ตอนนี้เรามีแอปพลิเคชัน Shopify เวอร์ชันดั้งเดิมที่สามารถติดตั้งได้จาก Shopify App Store แล้ว",
        "hyperlink": "คลิกที่นี่และทำการติดตั้ง Linguise จากแอปพลิเคชัน",
        "next_btn": "ไปที่ร้านค้า Shopify เพื่อติดตั้งแอป",
        "info_legacy": "ข่าวดี! ตอนนี้เรามีแอปพลิเคชัน Shopify เวอร์ชันดั้งเดิมที่สามารถติดตั้งได้จาก Shopify App Store แล้ว",
        "description_legacy": "เลือกแพลตฟอร์ม \"Shopify\" แทน \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "ข่าวดี! ตอนนี้เรามีแอปพลิเคชัน Wix เวอร์ชันดั้งเดิมที่สามารถติดตั้งได้จาก Wix App Market แล้ว",
        "hyperlink": "คลิกที่นี่และทำการติดตั้ง Linguise จากแอปพลิเคชัน",
        "next_btn": "ไปที่ Wix App Market เพื่อติดตั้งแอป",
        "info_legacy": "ข่าวดี! ตอนนี้เรามีแอปพลิเคชัน Wix เวอร์ชันดั้งเดิมที่สามารถติดตั้งได้จาก Wix App Market แล้ว",
        "description_legacy": "เลือกแพลตฟอร์ม \"Wix\" แทน \"Wix Legacy\""
      },
      "ai_disallow_deletion": "คุณไม่สามารถลบโดเมนนี้ได้ในขณะที่โควต้า AI ยังมีอยู่\n\nโปรดติดต่อทีมสนับสนุนของเราหากคุณต้องการลบโดเมนนี้ที่",
      "language_removal": {
        "card": {
          "title": "ลบคำแปลของภาษาที่นำออกแล้ว",
          "description": "ภาษาเหล่านี้ถูกนำออกจากเว็บไซต์แล้ว แต่คำแปลที่บันทึกไว้ยังนับรวมในโควตาของคุณ ลบคำแปลเหล่านี้เพื่อคืนจำนวนคำ",
          "button": "ลบคำแปล"
        },
        "hint": "จำนวนคำที่ใช้จะแสดงคืนในโควตา คุณทำรายการนี้ได้ทุก {{days}} วันต่อเว็บไซต์",
        "modal": {
          "title": "ลบคำแปลหรือไม่",
          "intro": "คำแปลเหล่านี้จะถูกลบอย่างถาวร:",
          "warning": "ไม่สามารถยกเลิกได้ จำนวนคำที่ใช้จะคืนสู่โควตา ซึ่งอาจใช้เวลาสักครู่",
          "limit": "คุณทำรายการนี้ได้ทุก {{days}} วันต่อเว็บไซต์",
          "confirm": "ลบคำแปล"
        },
        "scheduled": "กำลังลบคำแปล และโควตาของคุณจะอัปเดตในไม่ช้า",
        "cooldown": "คำแปลของเว็บไซต์นี้เพิ่งถูกลบ คุณจะลบอีกครั้งได้ในวันที่ {{date}}",
        "latest_completed": {
          "title": "รายการลบล่าสุดที่เสร็จสมบูรณ์",
          "description": "ตรวจสอบภาษาที่ลบและจำนวนคำที่คืนสู่โควตา",
          "languages": "ภาษาที่ลบแล้ว",
          "words_returned": "จำนวนคำที่คืนสู่โควตา: {{words}}",
          "completed_at": "เสร็จสิ้นเมื่อ {{date}}"
        },
        "status": {
          "recent_title": "การลบคำแปลล่าสุด",
          "recent_description": "ติดตามการลบล่าสุดและดูว่าจะเริ่มรายการถัดไปได้เมื่อใด",
          "progress_title": "ความคืบหน้าการลบ",
          "loading": "กำลังตรวจสอบความคืบหน้าการลบ...",
          "unavailable": "โหลดความคืบหน้าการลบไม่ได้ โปรดรีเฟรชหน้าแล้วลองอีกครั้ง",
          "label": "สถานะ",
          "pending": "อยู่ในคิว",
          "processing": "กำลังดำเนินการ",
          "completed": "เสร็จสมบูรณ์",
          "failed": "ล้มเหลว",
          "unknown": "ไม่มีสถานะ",
          "percent": "เสร็จแล้ว {{percent}}%",
          "current_stage": "ขั้นตอนปัจจุบัน: {{stage}}",
          "processed": "ประมวลผลแล้ว {{processed}} รายการ",
          "processed_total": "ประมวลผลแล้ว {{processed}} จาก {{total}} รายการ",
          "requested_at": "ส่งคำขอเมื่อ {{date}}",
          "started_at": "เริ่มเมื่อ {{date}}",
          "completed_at": "เสร็จสิ้นเมื่อ {{date}}",
          "cooldown_period": "คุณทำรายการนี้ได้ทุก {{days}} วันต่อเว็บไซต์",
          "cooldown_blocked": "ยังไม่สามารถเริ่มการลบรายการอื่นได้",
          "stage": {
            "queued": "กำลังรอเริ่ม",
            "processing": "กำลังดำเนินการ",
            "refund_summary": "กำลังคำนวณจำนวนคำที่คืน",
            "search_translations": "กำลังลบคำแปลการค้นหา",
            "url_translations": "กำลังลบคำแปล URL",
            "translations": "กำลังลบคำแปล",
            "completed": "เสร็จสมบูรณ์",
            "failed": "ล้มเหลว",
            "unknown": "กำลังดำเนินการ"
          }
        },
        "forbidden": "คุณไม่มีสิทธิ์ลบคำแปล"
      }
    },
    "main": {
      "edit": "แก้ไขโดเมน",
      "add": "เพิ่มโดเมน",
      "wizard": "ยินดีต้อนรับ! ตัวช่วยสร้างโดเมนใหม่",
      "common": "โดเมน"
    },
    "notice": {
      "broken_card": "เราไม่สามารถต่ออายุแผนของคุณสำหรับ {{url}} ด้วยวิธีการชำระเงินปัจจุบันได้ กรุณาอัปเดตบัตรเครดิตของคุณ",
      "quota_reached": "โควต้าแปลของคุณสำหรับ {{url}} ถูกใช้ครบแล้ว กรุณาอัปเกรดเพื่อดำเนินการแปลเว็บไซต์ต่อ",
      "ai_no_subscription": "การแปล AI สำหรับ {{url}} ต้องมีการสมัครใช้งานหรือทดลองใช้งานที่เปิดอยู่ หากไม่มีจะหยุดทำงาน กรุณาอัปเกรดเพื่อดำเนินต่อ",
      "important": "สำคัญ",
      "quota_reached_button": "อัปเกรดแผนของคุณตอนนี้",
      "broken_card_button": "อัปเดตบัตรชำระเงินของคุณ",
      "ai_no_subscription_button": "อัปเกรดแผนของคุณตอนนี้",
      "quota_warning": "โควต้าการแปลของคุณสำหรับ {{url}} ถึง {{throttling_used_percent}}% แล้ว ซึ่งจะถูกรีเซ็ตใน {{ttl}}",
      "locked": "ขณะนี้โดเมน {{url}} ถูกล็อคสำหรับการโยกย้าย คุณยังคงสามารถเข้าถึงเว็บไซต์ของคุณได้ แต่ไม่สามารถแก้ไขได้หรือเพิ่มคำแปลใหม่!"
    },
    "subdomains": {
      "config_ok": "DNS ของซับโดเมนได้กำหนดค่าอย่างถูกต้องแล้ว",
      "config_invalid": "DNS ของซับโดเมนต้องการการกำหนดค่าเพิ่มเติมเพื่อให้ทำงานได้",
      "config_check": "กำลังตรวจสอบการกำหนดค่า DNS ของซับโดเมน โปรดรอ...",
      "entri_timeout": "Entri รายงานว่ากระบวนการแพร่กระจาย DNS ของซับโดเมนของคุณได้หมดเวลา คุณต้องลองใหม่อีกครั้งหรือทำด้วยตนเอง",
      "entri_process": "DNS ของคุณได้ถูกเพิ่มกับ Entri และปกติใช้เวลา 10‑30 นาทีในการแพร่กระจาย (ใช้กับซับโดเมนทุกภาษาเช่น es.domain.com) หากการตรวจสอบ DNS ไม่เสร็จหลังจาก 24 ชั่วโมง คุณสามารถติดต่อทีมสนับสนุนของเราได้ที่: support@linguise.com",
      "entri_ok": "การแพร่กระจาย DNS กำลังดำเนินอยู่! รอการแพร่กระจาย...",
      "infos": "คุณต้องเพิ่มรายการ DNS เหล่านี้ลงในระเบียนโดเมน DNS ของคุณเพื่อเปิดใช้งานการแปล คลิกปุ่มตรวจสอบเมื่อดำเนินการเสร็จแล้ว การเผยแพร่ระเบียน DNS อาจใช้เวลาสักระยะ ดังนั้นคุณอาจต้องกลับมาตรวจสอบอีกครั้งหลังจากนั้นไม่กี่นาทีหรือหลายชั่วโมง",
      "check": "ตรวจสอบการตั้งค่า DNS"
    },
    "subscription": {
      "next_payment_amount": "ค่าใช้จ่ายที่กำลังจะเกิดขึ้น",
      "next_payment_date": "วันชำระเงินครั้งต่อไป",
      "invoice": {
        "header": "ประวัติงบิล",
        "date": "วันที่",
        "amount_due": "จำนวนเงิน",
        "status": "สถานะ",
        "actions": "การกระทำ",
        "description": "เมื่อทำรายการเสร็จ คุณสามารถดูได้ที่นี่",
        "status_text": {
          "draft": "ร่าง",
          "failed": "ล้มเหลว",
          "open": "รอดำเนินการ",
          "paid": "ชำระแล้ว",
          "retrying": "กำลังลองใหม่",
          "uncollectible": "ไม่สามารถเก็บได้",
          "void": "เป็นโมฆะ"
        },
        "view": "ดู",
        "empty": "ไม่พบใบแจ้งหนี้ล่าสุดสำหรับการสมัครนี้",
        "retry_payment": "ลองใหม่"
      },
      "next_cancellation": "วันยกเลิก",
      "cancel": "ยกเลิกการสมัคร",
      "change_plan": "เปลี่ยนแผน",
      "change": "เปลี่ยน",
      "suspend": "ระงับการชำระเงิน",
      "resume": "ต่ออายุการสมัคร",
      "back": "ย้อนกลับ",
      "save": "บันทึก",
      "confirm_resume": "คุณแน่ใจหรือว่าต้องการต่ออายุการสมัครนี้?",
      "confirm_cancel": "คุณแน่ใจหรือว่าต้องการยกเลิกการสมัครนี้?",
      "confirm_header": "คุณแน่ใจไหม?",
      "missing_status": "การสมัครนี้ขาดสถานะ",
      "not_found": "ไม่พบการสมัครสมาชิกสำหรับโดเมนนี้",
      "confirm_manual_retry": "คุณแน่ใจหรือว่าต้องการลองชำระเงินนี้ใหม่?",
      "no_payment_method": "ไม่ทราบ",
      "remove_billing": "ลบ",
      "shopify_maneged": "การสมัครนี้จัดการโดย Shopify โปรดจัดการจากแผงผู้ดูแล Shopify ของคุณ",
      "unknown_plan": "แผนไม่ทราบ"
    }
  },
  "domain_listing": {
    "add": "เพิ่มเว็บไซต์",
    "select": "เลือกโดเมน"
  },
  "editable": {
    "number": "หมายเลข {{id}}"
  },
  "footer": {
    "about": "เกี่ยวกับ",
    "support": "สนับสนุน"
  },
  "frontendEditor": {
    "main": "ตัวแก้ไขสด",
    "description": "Live Editor ช่วยให้คุณแก้ไขการแปลบนเว็บไซต์โดยตรง",
    "button": "เปิด Live Editor",
    "language_selection": "เลือกภาษาการแปล",
    "video_label": "เรียนรู้วิธีใช้ Live Editor"
  },
  "general": {
    "403": {
      "tab_title": "โอ๊ะ - ข้อผิดพลาด 403",
      "title": "การเข้าถึงถูกปฏิเสธ",
      "message": "ดูเหมือนคุณไม่มีสิทธิ์เข้าถึงหน้าที่ร้องขอ",
      "home": "กลับหน้าหลัก"
    },
    "404": {
      "tab_title": "โอ๊ะ - ข้อผิดพลาด 404",
      "title": "ไม่พบหน้า",
      "message": "ดูเหมือนคุณอาจเดินผิดทาง ไม่ต้องกังวล... เราทุกคนเคยเป็นเช่นนั้น นี่คือเคล็ดลับเล็ก ๆ ที่อาจช่วยให้คุณกลับสู่เส้นทาง",
      "home": "กลับหน้าหลัก"
    },
    "500": {
      "tab_title": "ข้อผิดพลาด 500",
      "title": "ข้อผิดพลาดเซิร์ฟเวอร์ภายใน",
      "message": "ลองรีเฟรชหน้าใหม่หรือคุณสามารถติดต่อเรา",
      "home": "กลับหน้าหลัก"
    },
    "fields": {
      "alert": "บางฟิลด์ไม่ถูกต้อง โปรดแก้ไขฟิลด์ที่ไม่ถูกต้อง",
      "invalid": "ฟิลด์นี้ไม่ถูกต้อง",
      "phone_re": "หมายเลขโทรศัพท์ไม่ถูกต้อง",
      "phone_invalid": "หมายเลขโทรศัพท์ไม่ถูกต้อง",
      "email": "ช่องอีเมลไม่ถูกต้อง"
    },
    "table": {
      "no_data": "ยังไม่มีข้อมูลที่นี่..."
    },
    "saving": "กำลังบันทึก ...",
    "save": "บันทึก",
    "save_and_quit": "บันทึกและออก",
    "invite": "เชิญ",
    "cancel": "ยกเลิก",
    "yes": "ใช่",
    "no": "ไม่",
    "nextStep": "ขั้นตอนต่อไป",
    "loading": "กรุณารอสักครู่ แอปพลิเคชันกำลังโหลด",
    "goback": "กลับไป",
    "manage": "จัดการ",
    "delete": "ลบ",
    "deleting": "กำลังลบ ...",
    "confirm": "ยืนยัน",
    "unknown": "ไม่ทราบ",
    "hide": "ซ่อน",
    "show": "แสดง",
    "on": "บน",
    "off": "ปิด",
    "default": "ค่าเริ่มต้น"
  },
  "home": {
    "header": "หน้าแรก",
    "manage": "จัดการการสมัคร",
    "canceled": "กำหนดให้ยกเลิก",
    "activate_now": "เปิดใช้งานตอนนี้",
    "activate_plan_now": "สมัครสมาชิกตอนนี้",
    "upgrade_plan_now": "อัปเกรดแผนตอนนี้",
    "trial_message_part_1": "คุณกำลังอยู่ในแผนทดลอง, ",
    "trial_message_part_2": "คุณสามารถเปิดใช้งานสมาชิกได้ตลอดเวลา",
    "add": "เพิ่มโดเมน",
    "table": {
      "title": "โดเมน",
      "description": "รายการโดเมนของคุณ คลิกที่โดเมนเพื่อจัดการการแปล"
    },
    "domains": {
      "empty": "คุณไม่มีโดเมนใดในบัญชีนี้"
    },
    "accountsList": {
      "title": "บัญชี",
      "add": "เพิ่มบัญชีใหม่",
      "name": "ชื่อบัญชี"
    },
    "update_credit_card": "อัปเดตรายละเอียดบัตรเครดิต",
    "cancelling_subs": "ยกเลิกที่ {{0}}",
    "resume_subscription": "กลับมาเป็นสมาชิกอีกครั้ง",
    "shopify_managed": "จัดการโดย Shopify",
    "trial_ends_at": "สิ้นสุดที่ {{0}}",
    "free_trial": "ทดลองใช้ฟรี",
    "no_subs": "ไม่มีการสมัครสมาชิกที่ใช้งาน"
  },
  "invoices": {
    "title": "ใบแจ้งหนี้",
    "list": {
      "title": "รายการใบแจ้งหนี้"
    },
    "table": {
      "customer": "ลูกค้า",
      "domain": "โดเมน",
      "amountPaid": "จำนวนเงินที่ชำระ",
      "status": "สถานะ",
      "date": "วันที่",
      "invoice": "ใบแจ้งหนี้",
      "pay": "ชำระใบแจ้งหนี้",
      "actions": "การกระทำ",
      "deleted_domain": "โดเมนถูกลบ",
      "plan_name": "แผน",
      "action": "การกระทำ"
    },
    "listPending": {
      "title": "รายการใบแจ้งหนี้ที่รอการชำระ"
    }
  },
  "language_settings": {
    "display": "การแสดงรายการภาษา",
    "position": "ตำแหน่ง",
    "display_help_text": "แสดงธงและ/หรือชื่อภาษา ตำแหน่งเริ่มต้นของตัวสลับภาษาสามารถอยู่ที่ใดก็ได้ในเนื้อหา หรืออยู่ในตำแหน่งคงที่ที่คงที่หรือเคลื่อนที่เมื่อเลื่อนหน้า",
    "side_by_side": "ข้างกัน",
    "dropdown": "ดรอปดาวน์",
    "popup": "ป๊อปอัป",
    "flag": "ธง",
    "lang_name": "ชื่อภาษา",
    "lang_short_name": "ชื่อสั้น",
    "positions": {
      "in_place": "ในตำแหน่งเดิม",
      "top_left": "บนซ้าย",
      "top_left_no_scroll": "บนซ้าย (ไม่มีการเลื่อน)",
      "top_right": "บนขวา",
      "top_right_no_scroll": "บนขวา (ไม่มีการเลื่อน)",
      "bottom_left": "ล่างซ้าย",
      "bottom_left_no_scroll": "ล่างซ้าย (ไม่มีการเลื่อน)",
      "bottom_right": "ล่างขวา",
      "bottom_right_no_scroll": "ล่างขวา (ไม่มีการเลื่อน)"
    },
    "lang_names_display": {
      "title": "การแสดงชื่อภาษา",
      "help_text": "ในตัวสลับภาษา ให้แสดงชื่อภาษาเป็นภาษาอังกฤษหรือเป็นภาษาต้นฉบับ เช่น French หรือ Français",
      "english": "อังกฤษ",
      "native_languages": "ภาษาท้องถิ่น"
    },
    "flag_shape": {
      "title": "รูปแบบธง",
      "help_text": "ใช้ไอคอนธง SVG แบบกลมหรือสี่เหลี่ยม",
      "round": "กลม",
      "rectangular": "สี่เหลี่ยม"
    },
    "english_flag_type": {
      "title": "ประเภทธงอังกฤษ",
      "help_text": "ใช้ธงอังกฤษของสหราชอาณาจักรหรือสหรัฐอเมริกาสำหรับภาษาอังกฤษ",
      "usa": "ธงสหรัฐอเมริกา",
      "great_britain": "ธงสหราชอาณาจักร"
    },
    "german_flag_type": {
      "title": "ประเภทธงเยอรมัน",
      "help_text": "ใช้ธงออสเตรียหรือเยอรมนีสำหรับภาษาเยอรมัน",
      "german": "ธงเยอรมนี",
      "austria": "ธงออสเตรีย"
    },
    "spain_flag_type": {
      "title": "ประเภทธงสเปน",
      "help_text": "ใช้ธงเม็กซิโกหรือสเปนสำหรับภาษาสเปน",
      "spanish": "ธงสเปน",
      "mexico": "ธงเม็กซิโก",
      "peruvian": "ธงเปรู"
    },
    "portugal_flag_type": {
      "title": "ประเภทธงโปรตุเกส",
      "help_text": "ใช้ธงโปรตุเกสหรือบราซิลสำหรับภาษาโปรตุเกส",
      "portugal": "ธงโปรตุเกส",
      "brazil": "ธงบราซิล"
    },
    "taiwanese_flag_type": {
      "title": "ประเภทธงไต้หวัน",
      "help_text": "ใช้ธงไต้หวันหรือจีนสำหรับภาษาไต้หวัน",
      "taiwanese": "ธงไต้หวัน",
      "chinese": "ธงจีน"
    },
    "flag_border_radius": {
      "title": "รัศมีขอบของธง (px)",
      "help_text": "หากคุณใช้รูปแบบธงสี่เหลี่ยม คุณสามารถตั้งค่ารัศมีขอบเป็นพิกเซลได้เอง"
    },
    "flag_width": {
      "title": "ขนาดธง (px)",
      "help_text": "เลือกขนาดธงเป็นพิกเซล ซึ่งไม่ทำให้ไฟล์ภาพหนักขึ้นเพราะเป็นรูปแบบ .svg"
    },
    "lang_color": {
      "color_title": "สีชื่อภาษา",
      "color_help_text": "เลือกสีข้อความเริ่มต้นสำหรับชื่อภาษาของคุณ",
      "hover_color_title": "สีชื่อภาษาขณะชี้เมาส์",
      "hover_color_help_text": "เลือกสีข้อความเมื่อนำเมาส์ไปชี้ที่ชื่อภาษา",
      "color_popup_title": "สีภาษาภายในป๊อปอัป",
      "color_popup_help_text": "สีของชื่อภาษาภายในป๊อปอัปหรือเมนูดรอปดาวน์",
      "hover_color_popup_title": "สีภาษาขณะชี้เมาส์ในป๊อปอัป",
      "hover_color_popup_help_text": "เลือกสีข้อความเมื่อนำเมาส์ไปชี้ที่ชื่อภาษาภายในป๊อปอัปหรือเมนูดรอปดาวน์"
    },
    "flag_box_shadow": {
      "shadow_title": "เงากล่องธง",
      "shadow_help_text": "สีและขนาดเงาสำหรับธงภาษาของคุณ",
      "hover_shadow_title": "เงากล่องธงเมื่อชี้เมาส์",
      "hover_shadow_help_text": "สีและขนาดเงาสำหรับธงภาษาของคุณเมื่อชี้เมาส์",
      "shadow_h_offset": "การเลื่อนเงาแนวนอน (px)",
      "shadow_v_offset": "การเลื่อนเงาแนวตั้ง (px)",
      "shadow_blur": "ความเบลอของเงา (px)",
      "shadow_spread": "การกระจายเงา (px)",
      "shadow_color": "สีเงา"
    },
    "order": "ลำดับภาษา",
    "language_order_help": "ลำดับของภาษาที่จะแสดงในตัวสลับภาษา คุณสามารถลากและวางเพื่อจัดลำดับใหม่ได้",
    "order_reset": "รีเซ็ตลำดับ",
    "language_order_dragdrop": "คุณสามารถลากและวางเพื่อจัดลำดับใหม่ได้",
    "popup_lang_name": "ชื่อภาษาป๊อปอัป",
    "preview": "ตัวอย่างภาษา"
  },
  "link": {
    "form": {
      "original": {
        "title": "แหล่งที่มาเดิม",
        "description": "เพิ่ม URL ลิงก์ต้นฉบับของคุณและแทนที่ด้วยภาษาที่ต้องการแปล",
        "srcset_description": "คุณกำลังแก้ไข URL ของภาพ โปรดตรวจสอบเอกสาร โดยเฉพาะอย่างยิ่งหากคุณใช้ srcset หรือไม่ทราบว่ามันคืออะไร",
        "link": "ลิงก์",
        "match_link": "โหมดจับคู่",
        "match_exact": "ตรงกันexact",
        "match_wildcard": "ไวลด์การ์ด",
        "match_regex": "เรกซ์"
      },
      "alternative_languages": {
        "title": "ลิงก์ที่จะแทนที่",
        "description": "แทนที่ลิงก์สื่อและลิงก์ภายนอกบนหน้าของคุณตามภาษา…",
        "link": "ลิงก์ที่จะแทนที่"
      },
      "error": {
        "atLeastOne": "กรุณาเพิ่มการแปลอย่างน้อยหนึ่งรายการ",
        "url": "URL ไม่ถูกต้อง",
        "extension": "ลิงก์ควรมีส่วนต่อท้ายไฟล์ แต่ไม่สามารถเป็น .html หรือ .php ได้ และลิงก์ไม่ควรมีเส้นทางภาษาตัวอย่างเช่น \"/fr\"",
        "regex": "รูปแบบ regex ไม่ถูกต้อง",
        "wildcard": "ลิงก์ไวลด์การ์ดมีโปรโตคอลไม่ถูกต้อง"
      }
    },
    "main": {
      "parent": "ลิงก์",
      "edit": "แก้ไขลิงก์"
    }
  },
  "links": {
    "title": "การจัดการลิงก์สื่อและลิงก์ภายนอก",
    "description": "แสดงรายการและแก้ไขลิงก์สื่อหรือลิงก์ภายนอกของเว็บไซต์ของคุณ",
    "add": "เพิ่มลิงก์",
    "delete": "ลบลิงก์",
    "table": {
      "original": "ต้นฉบับ",
      "language": "ภาษา",
      "translation": "การแปล",
      "action": "การกระทำ",
      "delete_confirm": "กรุณายืนยันการลบลิงก์"
    }
  },
  "members": {
    "header": "สมาชิก",
    "invite": "เชิญสมาชิกใหม่",
    "modal": {
      "inviteHeader": "เชิญสมาชิกใหม่",
      "editHeader": "แก้ไขสมาชิก",
      "detachHeader": "ถอดสมาชิก",
      "detachBody": "คุณแน่ใจหรือว่าต้องการถอดสมาชิกออกจากบัญชีนี้?",
      "selfDetachBody": "คุณแน่ใจหรือว่าต้องการถอดตัวเองออกจากการจัดการบัญชีนี้? หลังจากนั้นคุณจะไม่สามารถเข้าถึงข้อมูลใด ๆ ที่เกี่ยวข้องกับบัญชีนี้ได้"
    },
    "table": {
      "title": "รายการสมาชิก",
      "description": "บทบาทและการเข้าถึงโดเมนของสมาชิก",
      "name": "ชื่อ",
      "email": "อีเมล",
      "websites": "เว็บไซต์",
      "languages": "ภาษา",
      "role": "บทบาท",
      "status": "สถานะ",
      "resendInvite": "ส่งใหม่",
      "inviteSent": "ส่งคำเชิญแล้ว",
      "actions": "การกระทำ",
      "edit": "แก้ไข",
      "detach": "ถอด",
      "empty": "คุณยังไม่มีสมาชิก",
      "all_website": "เว็บไซต์และภาษาทั้งหมด",
      "roles": {
        "admin": "ผู้ดูแล",
        "manager": "ผู้จัดการ",
        "translator": "นักแปล"
      },
      "statuses": {
        "pending": "รอดำเนินการ",
        "accepted": "ยอมรับ",
        "declined": "ปฏิเสธ"
      }
    },
    "errors": {
      "role": "คุณต้องเลือกบทบาท",
      "domains": "คุณต้องเลือกอย่างน้อย 1 เว็บไซต์สำหรับบทบาทที่เลือก",
      "languages": "คุณต้องเลือกอย่างน้อย 1 ภาษาสำหรับเว็บไซต์ที่เลือก"
    },
    "inviteSent": "คำเชิญของคุณได้ถูกส่งเรียบร้อยแล้ว"
  },
  "pagination": {
    "showing": "แสดง {{limit}} จาก {{total}} ผลลัพธ์",
    "showing_only_count": "แสดง {{limit}} ผลลัพธ์"
  },
  "payments_method": {
    "header": "วิธีการชำระเงิน",
    "table": {
      "title": "รายการวิธีการชำระเงิน",
      "description": "วิธีการชำระเงินที่แนบกับบัญชีของคุณ",
      "default": "ค่าเริ่มต้น",
      "action_edit_remove": "แก้ไขหรือเอาออก",
      "action_remove": "เอาออก",
      "action_default": "ตั้งเป็นค่าเริ่มต้น",
      "action_fallback": "ตั้งเป็นสำรอง",
      "expires": "หมดอายุ",
      "add_new_card": "เพิ่มวิธีการชำระเงิน",
      "action_fallback_remove": "เอาออกจากสำรอง",
      "fallback": "สำรอง",
      "action_edit": "แก้ไข",
      "action_delete": "ลบ",
      "action_default_remove": "ยกเลิกการเป็นค่าเริ่มต้น",
      "domain_count@@one": "ใช้โดย {{count}} โดเมน",
      "domain_count@@other": "ใช้งานโดยโดเมนจำนวน {{count}} โดเมน"
    },
    "paypal_bind": {
      "button": "เชื่อมต่อบัญชี PayPal",
      "button_load": "กำลังเชื่อมต่อ...",
      "disconnected": "ไม่ได้เชื่อมต่อ",
      "success": "บัญชี PayPal ของคุณเชื่อมต่อแล้ว จะหัก $5 จากใบแจ้งหนี้ครั้งถัดไป!",
      "success_no_promo": "บัญชี PayPal ของคุณเชื่อมต่อแล้ว",
      "error": "เกิดข้อผิดพลาด",
      "success_header": "สำเร็จ"
    },
    "card_add": {
      "header": "เพิ่มบัตรใหม่",
      "success": "เพิ่มบัตรใหม่เชื่อมต่อกับ Linguise แล้ว!",
      "terms": "โดยการให้ข้อมูลบัตรของคุณ คุณยอมให้ Linguise เรียกเก็บเงินจากบัตรของคุณสำหรับการชำระเงินในอนาคตตามเงื่อนไขการให้บริการของเรา"
    },
    "card_detail": {
      "header": "ข้อมูลบัตร",
      "delete": {
        "error": "คุณไม่สามารถลบวิธีการชำระเงินนี้ได้เนื่องจากมีการสมัครสมาชิกที่ยังใช้งานอยู่!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "การสมัครสมาชิกบนวิธีการชำระเงินนี้",
        "header_domain": "โดเมน",
        "header_plan": "แผน",
        "header_status": "สถานะ",
        "header_actions": "การกระทำ",
        "cancelling": "กำลังยกเลิกที่: {{0}}",
        "next_payment": "การชำระเงินครั้งต่อไปที่: {{0}}",
        "action_renew": "ต่ออายุ",
        "no_subs_header": "ไม่มีการสมัครสมาชิกให้แสดง",
        "no_subs_desc": "เมื่อมีการสมัครสมาชิกกับบัตรนี้ ข้อมูลทั้งหมดจะปรากฏที่นี่",
        "action_manage": "จัดการ"
      },
      "status": {
        "active": "ใช้งานอยู่",
        "canceled": "ยกเลิก",
        "incomplete": "ค้างชำระ",
        "incomplete_expired": "ค้างชำระ (หมดอายุ)",
        "missing": "ข้อผิดพลาด",
        "past_due": "เกินกำหนด",
        "trialing": "ทดลองใช้",
        "unpaid": "ค้างชำระ"
      }
    },
    "delete_confirm_body": "คุณแน่ใจหรือว่าต้องการลบวิธีการชำระเงินนี้? การกระทำนี้ไม่สามารถย้อนกลับได้!",
    "delete_confirm_header": "ลบวิธีการชำระเงิน?",
    "card_edit": {
      "header": "แก้ไขบัตร",
      "billing_header": "ข้อมูลการเรียกเก็บเงิน",
      "address_error": "ต้องระบุที่อยู่!",
      "card_number": "หมายเลขบัตร",
      "card_expiry": "วันหมดอายุ",
      "expiry_error_month": "เดือนที่ระบุไม่ถูกต้อง",
      "expiry_error_year": "ปีที่ระบุไม่ถูกต้อง",
      "expiry_error_expired": "ปีหมดอายุของบัตรของคุณอยู่ในอดีต",
      "card_header": "ข้อมูลบัตร",
      "expiry_error_empty": "ต้องระบุฟิลด์นี้!"
    }
  },
  "plans": {
    "per": "ต่อ",
    "wordsTranslated": "คำที่แปลแล้ว",
    "current": "ปัจจุบัน",
    "archived": "เก็บไว้",
    "day": "วัน",
    "week": "สัปดาห์",
    "month": "เดือน",
    "year": "ปี",
    "activate": "เปิดใช้งาน",
    "cancel": "ยกเลิก",
    "change": "เปลี่ยนแปลง",
    "upgrade": "อัปเกรด",
    "downgrade": "ดาวน์เกรด",
    "resume": "ดำเนินการต่อ",
    "notEnoughWords": "คำไม่เพียงพอ",
    "yearIntervalOnly": "ไม่สามารถย้ายจากแผนรายปีได้",
    "subsCanceled": "มีการยกเลิกการสมัครสมาชิกอื่นอยู่ในระหว่างดำเนินการ",
    "wordsUnlimited": "คำไม่จำกัด",
    "tabs": {
      "day": "ราคา รายวัน",
      "week": "ราคา รายสัปดาห์",
      "month": "ราคา รายเดือน",
      "year": "ราคา รายปี",
      "sub_texts": {
        "day": "ราคาคงที่หนึ่งครั้งต่อวัน",
        "week": "ราคาคงที่หนึ่งครั้งต่อสัปดาห์",
        "month": "ราคาคงที่หนึ่งครั้งต่อเดือน",
        "year": "หนึ่งเดือนฟรี, หนึ่งบิลต่อปี"
      }
    },
    "details": {
      "new_languages": "เพิ่มภาษาใหม่ได้ตลอดเวลา",
      "one_month_trial": "ทดลองฟรีหนึ่งเดือนสำหรับเว็บไซต์ใหม่ทุกเว็บ",
      "multi_content_indexed": "เนื้อหาหลายภาษาถูกจัดทำดัชนี 100%",
      "translate_new_content": "แปลเนื้อหาใหม่โดยทันที",
      "free_installation": "การติดตั้งและตั้งค่า ฟรี",
      "compared_monthly_plan": "หนึ่งเดือนฟรีเมื่อเทียบกับแผนรายเดือน",
      "risk_free_recurring": "การชำระเงินแบบต่อเนื่องไร้ความเสี่ยงต่อการล้มเหลว",
      "unlimited_languages": "ภาษาที่ไม่มีขีดจำกัดและการดูหน้าเว็บ",
      "high_server_resources": "ทรัพยากรเซิร์ฟเวอร์สูง",
      "billed": {
        "day": "เรียกเก็บเงินรายวัน",
        "week": "เรียกเก็บเงินรายสัปดาห์",
        "month": "เรียกเก็บเงินรายเดือน",
        "year": "เรียกเก็บเงินรายปี"
      },
      "request_max_size": "{{0}} ขนาดคำขอสูงสุด"
    },
    "frequent_question": {
      "title": "คำถามบ่อย",
      "questions": {
        "trial": {
          "question": "ฉันสามารถใช้การทดลองบนโดเมนเว็บไซต์ใหม่ได้หรือไม่?",
          "answer": "ใช่ เรามีการทดลองฟรี 30 วันสำหรับโดเมนเว็บไซต์ใหม่ทุกโดเมนที่คุณเพิ่มในบัญชีของคุณ เพื่อให้คุณสามารถทดสอบบริการแปลภาษาได้อย่างเต็มที่บนเว็บไซต์ใหม่ของคุณ"
        },
        "seo": {
          "question": "ใช้เวลานานแค่ไหนที่ SEO ของฉันจะพัฒนายิ่งขึ้น?",
          "answer": "เนื้อหาและเนื้อหาหลายภาษาต้องใช้เวลาในการจัดทำดัชนีและจัดอันดับอย่างเต็มที่ ขึ้นอยู่กับปริมาณการเข้าชมและขนาดของเว็บไซต์ของคุณ ระหว่าง 3 ถึง 6 สัปดาห์"
        },
        "quota": {
          "question": "การแปลโดยมนุษย์รวมอยู่ในโควต้าหรือไม่?",
          "answer": "ไม่ ค่าจำนวนคำจำกัดเฉพาะการแปลอัตโนมัติเครื่องจักรเท่านั้น ผู้แปลสามารถแก้ไขการแปลอัตโนมัติด้วยตนเองโดยไม่มีขีดจำกัด"
        }
      }
    },
    "best_offer": "ข้อเสนอดีที่สุด",
    "period": {
      "days@@one": "วัน",
      "days@@other": "{{count}} วัน",
      "hours@@one": "ชั่วโมง",
      "hours@@other": "{{count}} ชั่วโมง",
      "minutes@@one": "นาที",
      "minutes@@other": "{{count}} นาที",
      "seconds@@one": "วินาที",
      "seconds@@other": "{{count}} วินาที"
    },
    "words": {
      "billion": "{{value}}พันล้าน",
      "million": "{{value}}ล้าน",
      "thousand": "{{value}}พัน"
    },
    "throttling_info": "{{words}} คำต่อ {{period}}"
  },
  "profile": {
    "welcome": "ยินดีต้อนรับ!",
    "account": "บัญชีของฉัน",
    "subscriptions": "การสมัครสมาชิก",
    "logout": "ออกจากระบบ"
  },
  "register": {
    "errors": {
      "password": "ขั้นต่ำ 8 ตัวอักษร, ตัวอักษรใดก็ได้"
    }
  },
  "route": {
    "dashboard": "แดชบอร์ด",
    "rules": "กฎ",
    "translations": "การแปล",
    "search_translations": "ค้นหาแบบสอบถาม",
    "urls_translations": "การแปล URL",
    "links": "สื่อและลิงก์ภายนอก",
    "online_editor": "ตัวแก้ไขสด",
    "settings": "การตั้งค่า",
    "domain": {
      "finish": "การตั้งค่า",
      "preconfig": "การตั้งค่า"
    },
    "home": "หน้าแรก",
    "domain_list": "รายการโดเมน",
    "members": "สมาชิก",
    "invoices": "ใบแจ้งหนี้",
    "billing": "รายละเอียดการเรียกเก็บเงิน",
    "language_display": "การแสดงธงภาษ",
    "payment_methods": "วิธีการชำระเงิน",
    "ai_translation": "การแปล AI",
    "ai_translation_settings": "การตั้งค่า",
    "ai_translation_pricing": "ราคา"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "ข้อความที่ต้องละเว้น",
        "add": "เพิ่มใหม่",
        "title": "ข้อความที่ต้องละเว้น",
        "description": "เพิ่มหนึ่งหรือหลายข้อความเพื่อละเว้น",
        "ignore_case": "ละเว้นตัวพิมพ์ใหญ่/เล็ก"
      },
      "html_content": {
        "title": "ใช้กับเนื้อหา HTML",
        "description": "ใช้กฎกับเนื้อหาทั้งหมดหรือโดยการเลือก CSS selector เฉพาะ",
        "all_page": "ทุกหน้า",
        "css_selector": "ตัวเลือก CSS",
        "label": "ตัวเลือก CSS",
        "placeholder": "ตัวเลือกที่ใช้",
        "add": "เพิ่มใหม่"
      },
      "apply_to_urls": {
        "title": "ใช้กับ URL",
        "description": "เลือก URL เฉพาะที่คุณต้องการให้กฎนี้ทำงาน",
        "all_urls": "ทุก URL",
        "selected_urls": "เลือก URL",
        "label": "URL ที่จะใช้",
        "placeholder": "URL ที่จะใช้",
        "original_url": "URL ดั้งเดิม",
        "translated_url": "URL ที่แปล",
        "wildcard": "ไวด์การ์ด",
        "regex": "นิพจน์ปกติ",
        "add": "เพิ่มใหม่",
        "expression": "ประเภทของนิพจน์"
      },
      "apply_urls": {
        "title_exclude": "ยกเว้นใน URL",
        "title_replace": "แทนที่ใน URL",
        "title_description": "ใช้กฎนี้กับการแปลของ URL ด้วย"
      },
      "apply_languages": {
        "title": "ใช้กับภาษา",
        "description": "เลือกภาษาที่คุณต้องการให้กฎนี้ทำงาน",
        "all_languages": "ทุกภาษา",
        "selected_languages": "เลือกภาษา",
        "placeholder": "เลือกภาษา...",
        "feedback": "คุณต้องเลือกภาษา"
      },
      "name": {
        "title": "ชื่อ",
        "description": "ตั้งชื่อกฎเพื่อความสะดวก",
        "placeholder": "ชื่อกฎ"
      },
      "type": {
        "title": "ประเภท",
        "description": "เลือกประเภทของกฎที่คุณต้องการเพิ่ม",
        "text_ignore": "ละเว้นข้อความ",
        "text_replace": "แทนที่ข้อความ",
        "content_exclusion": "ยกเว้นเนื้อหา",
        "url_exclusion": "ยกเว้นตาม URL",
        "ignore_inline": "ละเว้นอินไลน์",
        "full_description": {
          "text_ignore": "เพิ่มกฎเพื่อหลีกเลี่ยงการแปลข้อความบางส่วน เช่น ชื่อสินค้า ชื่อแบรนด์ หรือส่วนเทคนิคที่คุณไม่ต้องการให้แปล",
          "text_replace": "การแทนที่ข้อความช่วยให้คุณเปลี่ยนข้อความเป็นการแปลที่ต้องการ เมื่อการแปลไม่สอดคล้องกับบริบท",
          "content_exclusion": "การยกเว้นเนื้อหาจะช่วยให้คุณหลีกเลี่ยงการแปลส่วนบางของหน้า หากต้องการยกเว้นหน้าทั้งหมดจากการแปล (ไม่มี URL หลายภาษาและไม่มีเนื้อหาที่แปล) โปรดใช้ประเภท \"ยกเว้นตาม URL\"",
          "url_exclusion": "การยกเว้นการแปลหน้า จะช่วยคุณกำหนดหน้าที่ไม่ต้องการแปล",
          "ignore_inline": "หลีกเลี่ยงการแปลเนื้อหาแบบอินไลน์ แปลแต่ละแท็กแยกกันแทน"
        }
      },
      "text_replace": {
        "title": "ข้อความที่จะแทนที่",
        "description": "แทนที่ข้อความด้วยการแปลที่คุณกำหนด แทนที่ข้อความใดก็ได้ในหน้า ตามภาษา...",
        "text_to_replace": "ข้อความที่จะแทนที่",
        "ignore_case": "ละเว้นตัวพิมพ์ใหญ่/เล็ก",
        "text_type": "การแทนที่ในการแปล",
        "text_type_original": "ต้นฉบับ",
        "text_type_translation": "การแปล",
        "keep_case": "พยายามรักษาตัวพิมพ์",
        "add": "เพิ่มใหม่"
      },
      "content_exclusion": {
        "title": "ยกเว้นเนื้อหา",
        "description": "เลือกตัวเลือก CSS หนึ่งหรือหลายตัวที่ไม่ต้องการให้แปล",
        "label": "ตัวเลือก CSS",
        "placeholder": "เลือกตัวเลือกที่จะใช้",
        "add": "เพิ่มใหม่"
      },
      "multilingual_url": {
        "title": "ใช้ URL หลายภาษา",
        "description": "ถ้าตั้งค่าเป็นใช่ URL จะไม่ถูกแปล แต่หน้าจะยังคงเป็นหลายภาษาโดยมีเนื้อหาแปลแล้ว",
        "live_example_title": "ตัวอย่างสด",
        "live_example_description": "URL ต้นฉบับ: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "URL ที่สร้าง: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "URL ที่สร้าง: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "ใช้กฎกับเนื้อหาคงที่หรือเนื้อหาไดนามิกหรือทั้งสองอย่าง",
        "title": "ใช้กับเนื้อหา",
        "all": "เนื้อหาทั้งหมด",
        "static": "เนื้อหาคงที่",
        "dynamic": "เนื้อหาไดนามิก"
      },
      "force_apply_urls": {
        "title_description": "บังคับใช้กฎนี้กับการแปล URL ทั้งหมด รวมถึงการแปลที่มีอยู่แล้ว!",
        "title_replace": "บังคับแทนที่ใน URL",
        "title_exclude": "บังคับยกเว้นใน URL",
        "warning": "คำเตือน",
        "warning_part1": "การตั้งค่านี้เป็น \"ใช่\" อาจทำให้การแปล URL ของเว็บไซต์ของคุณเสียหาย",
        "warning_part2": "อาจทำให้เกิดหน้า 404 ชั่วคราวหรือถาวร โปรดดำเนินการต่อเฉพาะเมื่อคุณเข้าใจผลกระทบ",
        "warning_replacement_original": "คำเตือนเพิ่มเติม: คุณกำลังพยายามแทนที่เนื้อหาต้นฉบับที่อาจส่งผลต่อ URL การแปลอาจล้มเหลวเนื่องจาก Linguise ไม่พบ URL ต้นฉบับอย่างถูกต้อง"
      }
    },
    "main": {
      "parent": "กฎ",
      "edit": "แก้ไขกฎ",
      "add": "กฎใหม่"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" จะถูกละเว้นในเนื้อหาและ URL",
      "preview_single": "\"{{text_ignore}}\" จะถูกละเว้นในเนื้อหา",
      "preview_more_with_url": "\"{{text_ignore}}\" และ {{count}} รายการอื่นจะถูกละเว้นในเนื้อหา",
      "preview_more": "\"{{text_ignore}}\" และ {{count}} รายการอื่นจะถูกละเว้นในเนื้อหา",
      "other_parameters": "มีพารามิเตอร์อื่นตั้งค่าสำหรับกฎนี้ คลิกปุ่มแก้ไขเพื่อดูข้อมูลเพิ่มเติม"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" ถูกแทนที่ด้วย \"{{replacement}}\" ในเนื้อหาและ URL",
      "preview_single": "\"{{original}}\" ถูกแทนที่ด้วย \"{{replacement}}\" ในเนื้อหา",
      "preview_more_with_url": "\"{{original}}\" ถูกแทนที่ด้วย \"{{replacement}}\" ในเนื้อหาและ URL, และ {{nb}} รายการอื่น",
      "preview_more": "\"{{original}}\" ถูกแทนที่ด้วย \"{{replacement}}\" ในเนื้อหา, และ {{nb}} รายการอื่น",
      "other_parameters": "มีพารามิเตอร์อื่นตั้งค่าสำหรับกฎนี้ คลิกปุ่มแก้ไขเพื่อดูข้อมูลเพิ่มเติม"
    },
    "content_exclusion": {
      "selectors": "{{nb}} ตัวเลือก CSS ถูกยกเว้นจากการแปล",
      "other_parameters": "มีพารามิเตอร์อื่นตั้งค่าสำหรับกฎนี้ คลิกปุ่มแก้ไขเพื่อดูข้อมูลเพิ่มเติม"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL ถูกยกเว้นจากการแปล แต่ยังคงรักษา Prefix หลายภาษา",
      "some": "{{nb}} URL ถูกยกเว้นจากการแปลทั้งหมด",
      "all_multilingual": "ทั้งหมดของ URL ถูกยกเว้นจากการแปล แต่ยังคงรักษา Prefix หลายภาษา",
      "all": "ทั้งหมดของ URL ถูกยกเว้นจากการแปลทั้งหมด",
      "other_parameters": "มีพารามิเตอร์อื่นตั้งค่าสำหรับกฎนี้ คลิกปุ่มแก้ไขเพื่อดูข้อมูลเพิ่มเติม"
    },
    "ignore_inline": {
      "elements": "เนื้อหาอินไลน์ทั้งหมดจะถูกแปลเป็นบล็อกในหน้า",
      "all_elements": "เนื้อหาอินไลน์บางส่วนจะถูกแปลเป็นบล็อกในหน้า",
      "other_parameters": "มีการตั้งค่าพารามิเตอร์อื่นๆ สำหรับกฎนี้ คลิกปุ่มแก้ไขเพื่อดูข้อมูลเพิ่มเติม"
    },
    "title": "การจัดการกฎ",
    "description": "จัดการการยกเว้นและการแทนที่เนื้อหาการแปลทั่วทั้งเว็บไซต์ของคุณ",
    "add": "เพิ่มกฎใหม่",
    "table": {
      "title": "ชื่อ",
      "no_data": "ยังไม่มีกฎใด ๆ",
      "type": "ประเภท",
      "preview": "ตัวอย่างกฎ",
      "action": "การกระทำ",
      "delete_confirm": "กรุณายืนยันการลบกฎ",
      "types": {
        "text_ignore": "ละเว้นข้อความ",
        "text_replace": "แทนที่ข้อความ",
        "content_exclusion": "การยกเว้นเนื้อหา",
        "url_exclusion": "การยกเว้น URL",
        "ignore_inline": "ละเว้นแบบอินไลน์",
        "unknown": "กฎที่ไม่ทราบ"
      }
    },
    "apply_on_content": {
      "static": "กฎนี้จะใช้กับเนื้อหาคงที่เท่านั้น",
      "dynamic": "กฎนี้จะใช้กับเนื้อหาแบบไดนามิกเท่านั้น"
    }
  },
  "search_translations": {
    "title": "การจัดการคำค้นหา",
    "description": "แสดงรายการการแปลเว็บไซต์ทั้งหมดที่ใช้ผ่านแบบฟอร์มค้นหา (จากภาษาที่แปลเป็นภาษาพื้นฐานของโดเมนของคุณ)",
    "filter_languages": "กรองตามภาษา...",
    "filter_original": "กรองข้อความในภาษาต้นฉบับ",
    "filter_translation": "กรองตามข้อความที่แปล",
    "table": {
      "original": "ต้นฉบับ",
      "language": "ภาษา",
      "translation": "การแปล"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "การสมัครล้มเหลว!",
      "title": "การสมัครล้มเหลว!",
      "subtitle": "เกิดข้อผิดพลาดขณะพยายามประมวลผลการสมัครของคุณ",
      "home": "กลับไปหน้าแรก",
      "generic": "เกิดข้อผิดพลาดที่ไม่รู้จักในระบบ Linguise โปรดติดต่อผู้ดูแล!"
    },
    "success": {
      "home": "จัดการการแปลโดเมน",
      "message": "เรามุ่งมั่นที่จะมอบประสบการณ์การแปลที่ดีที่สุดให้คุณ ทีมผู้เชี่ยวชาญของเราพร้อมให้ความช่วยเหลือในทุกคำถามหรือสนับสนุนที่คุณต้องการ เพียงคลิกปุ่มด้านล่างเพื่อเริ่มต้น",
      "subtitle": "ขอบคุณที่เลือกใช้บริการแปลของ Linguise",
      "title": "เปิดใช้งานการสมัครแล้ว!",
      "tab_title": "ขอบคุณสำหรับการสมัคร!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "เปิดใช้งานการสมัครแล้ว!",
      "title": "เปิดใช้งานการสมัครแล้ว!",
      "subtitle": "ขอบคุณที่เลือกใช้บริการแปลของ Linguise",
      "message": "'เรามุ่งมั่นที่จะมอบประสบการณ์การแปลที่ดีที่สุดให้คุณ ทีมผู้เชี่ยวชาญของเราพร้อมให้ความช่วยเหลือในทุกคำถามหรือสนับสนุนที่คุณต้องการ เพียงคลิกปุ่มด้านล่างเพื่อเริ่มต้น",
      "home": "จัดการการแปลโดเมน"
    },
    "edit": {
      "title": "จัดการการสมัคร"
    },
    "list": {
      "title": "รายการการสมัคร",
      "description": "รายการการสมัครโดเมนของคุณ"
    },
    "table": {
      "domain": "โดเมน",
      "plan": "แผน",
      "status": "สถานะ",
      "card": "บัตร",
      "usage": "การใช้",
      "actions": "การกระทำ",
      "payment_method": "วิธีการชำระเงิน"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} คำ",
      "paidOffered": "{{words_used}} / {{words_allowed}} คำ\n(รวม {{free_words}} คำที่เสนอ)"
    },
    "popup": {
      "dueToday": "รวมยอดวันนี้",
      "nextPeriod": "เริ่มตั้งแต่ {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "เลือกบัญชี"
    }
  },
  "translation": {
    "main": {
      "parent": "การแปล",
      "edit": "แก้ไขการแปล"
    },
    "form": {
      "original": {
        "title": "ต้นฉบับใน {{language}}"
      },
      "is_inline": "การแปลนี้ทำจากเนื้อหาอินไลน์",
      "inline_editor": {
        "count_warning": "จำนวนพื้นที่แบบอินไลน์ไม่ตรงกับต้นฉบับ ({{current}} จาก {{expected}})",
        "restore_original": "คืนค่าข้อความต้นฉบับ",
        "insert_placeholder": "แทรกตัวแทนข้อความ",
        "drag": "ลากเพื่อจัดเรียงพื้นที่ใหม่",
        "area": "พื้นที่อินไลน์ {{index}}",
        "restore": "คืนค่าพื้นที่แบบอินไลน์ที่ขาดหายไป"
      },
      "translation": {
        "title": "การแปลใน {{language}}",
        "description": "การแปลที่คุณต้องการแทนที่"
      }
    },
    "copy": {
      "title": "คัดลอกไปยังการแปลด้วยตนเอง",
      "label": "คัดลอกไปยังด้วยตนเอง"
    },
    "level": {
      "base": {
        "title": "การแปลพื้นฐาน",
        "subtitle": "อัตโนมัติ · การแปลโดย Linguise Cloud",
        "empty": "ไม่มีการแปลพื้นฐานสำหรับข้อความนี้",
        "overridden": "บันทึกตัวเลือกของคุณแล้ว แต่จะแสดงการแปลที่ปรับปรุงด้วย AI ล่าสุดแทน เพราะ “แทนที่การแปลด้วยตนเองและการแปลที่เลือก” ตั้งเป็น ใช่ ในการตั้งค่าการแปล AI ปิดการตั้งค่านี้เพื่อใช้ตัวเลือกของคุณ"
      },
      "not_generated": "ยังไม่ได้สร้าง",
      "none": "ยังไม่มี",
      "ai": {
        "title": "การแปลที่ปรับปรุงด้วย AI",
        "subtitle": "อัตโนมัติ · Linguise AI",
        "empty_title": "ยังไม่ได้สร้างสำหรับข้อความนี้",
        "empty_description": "Linguise AI ให้การแปลที่เป็นธรรมชาติมากขึ้นโดยใช้บริบทของหน้าและเว็บไซต์ของคุณ หากต้องการให้มีที่นี่:",
        "empty_step_1": "ไปที่ การแปล AI › การตั้งค่า แล้วตั้งค่า เปิดใช้งานการแปล AI เป็น “ใช้กฎเท่านั้น”, “Live editor เท่านั้น” หรือ “กฎและ Live editor”",
        "empty_step_2": "ใช้งานด้วยกฎที่ตรงกับหน้านี้ หรือเปิดใช้งานทีละหน้าจาก Live Editor",
        "empty_step_3": "การแปลที่ปรับปรุงด้วย AI จะปรากฏที่นี่เมื่อสร้างเสร็จ และจะใช้เครดิต AI ของคุณ",
        "open_settings": "เปิดการตั้งค่าการแปล AI",
        "open_editor": "เปิด Live Editor",
        "overrides_selection": "บันทึกตัวเลือกของคุณแล้ว แต่จะแสดงการแปลที่ปรับปรุงด้วย AI นี้แทน เพราะ “แทนที่การแปลด้วยตนเองและการแปลที่เลือก” ตั้งเป็น ใช่ ในการตั้งค่าการแปล AI ปิดการตั้งค่านี้เพื่อใช้ตัวเลือกของคุณ",
        "overrides_version": "บันทึกเวอร์ชันที่คุณเลือกแล้ว แต่จะแสดงเวอร์ชันที่ปรับปรุงด้วย AI ล่าสุดแทน เพราะ “แทนที่การแปลด้วยตนเองและการแปลที่เลือก” ตั้งเป็น ใช่ ในการตั้งค่าการแปล AI ปิดการตั้งค่านี้เพื่อใช้เวอร์ชันที่เลือก"
      },
      "manual": {
        "title": "การแปลด้วยตนเอง",
        "subtitle": "เขียนโดยคุณ · มีลำดับความสำคัญเหนือการแปลอัตโนมัติ",
        "empty": "ว่างเปล่า",
        "saved_but_overridden": "บันทึกเป็นตัวเลือกของคุณแล้ว แต่ไม่แสดงอัตโนมัติ เพราะ “แทนที่การแปลด้วยตนเอง” ตั้งเป็น ใช่ ในการตั้งค่าการแปล AI: การแปลที่ปรับปรุงด้วย AI จะมีผลจนกว่าจะปิดการตั้งค่านี้",
        "ignored": "ไม่แสดงอัตโนมัติ เพราะ “แทนที่การแปลด้วยตนเอง” ตั้งเป็น ใช่ ในการตั้งค่าการแปล AI เลือกเพื่อใช้กับข้อความนี้",
        "label": "การแปลของคุณ",
        "placeholder": "พิมพ์คำแปลของคุณเอง...",
        "last_updated": "แก้ไขล่าสุด {{date}}",
        "save_hint": "เมื่อบันทึกการแปลด้วยตนเอง การแปลนั้นจะถูกใช้งานทันที",
        "delete": "ลบการแปลด้วยตนเอง",
        "delete_confirm": "กรุณายืนยันการลบการแปลด้วยตนเอง"
      }
    },
    "history": {
      "title": "เวอร์ชันที่ปรับปรุงด้วย AI",
      "subtitle": "ทุกการสร้างใหม่จาก Live Editor จะถูกเก็บไว้",
      "unknown_model": "ไม่ทราบโมเดล",
      "current": "ปัจจุบัน",
      "restore": "กู้คืนเวอร์ชันนี้",
      "restore_note": "การกู้คืนจะทำให้เวอร์ชันนั้นเป็นการแปลที่ปรับปรุงด้วย AI ปัจจุบัน ไม่มีอะไรถูกลบ",
      "version_of": "เวอร์ชัน {{current}} จาก {{total}}",
      "hide": "ซ่อนประวัติ ({{total}})",
      "show": "แสดงประวัติ ({{total}})"
    },
    "choose": {
      "title": "การแปลเป็น{{language}} · เลือกอันที่ผู้เข้าชมจะเห็น",
      "current": "ที่แสดงบนเว็บไซต์ของคุณตอนนี้:",
      "priority": "ลำดับความสำคัญเริ่มต้น: ด้วยตนเอง › ปรับปรุงด้วย AI › พื้นฐาน ตัวเลือกของคุณจะบันทึกสำหรับการแปลนี้เท่านั้น",
      "reset": "รีเซ็ตเป็นลำดับความสำคัญเริ่มต้น",
      "reset_title": "ลืมตัวเลือกของคุณสำหรับข้อความนี้ และกลับไปใช้ลำดับความสำคัญเริ่มต้น",
      "resetting": "กำลังรีเซ็ต ..."
    }
  },
  "translations": {
    "title": "การจัดการการแปล",
    "description": "แสดงรายการและแก้ไขการแปลเว็บไซต์ทั้งหมด สำหรับการแปลแบบภาพใช้ Live Editor",
    "filter_languages": "กรองตามภาษา...",
    "filter_original": "กรองข้อความในภาษาต้นฉบับ",
    "filter_translation": "กรองตามข้อความที่แปล",
    "table": {
      "original": "ต้นฉบับ",
      "language": "ภาษา",
      "action": "การกระทำ",
      "base": "พื้นฐาน",
      "ai": "ปรับปรุงด้วย AI",
      "manual": "ด้วยตนเอง"
    },
    "filter_exact": "ตรงกันเป๊ะ",
    "badge": {
      "active": "ใช้งานอยู่",
      "overrides_manual": "แทนที่ด้วยตนเอง"
    },
    "cell": {
      "none": "ไม่มี",
      "not_generated": "ยังไม่ได้สร้าง",
      "ignored": "ถูกข้าม – กฎ AI มีผล"
    },
    "tabs": {
      "all": "ทั้งหมด",
      "manual": "มีด้วยตนเอง",
      "ai": "มีที่ปรับปรุงด้วย AI",
      "base": "พื้นฐานเท่านั้น"
    },
    "levels_hint": "แต่ละข้อความมีได้สูงสุด 3 ระดับ — ระดับที่ทำเครื่องหมาย ใช้งานอยู่ คือสิ่งที่ผู้เข้าชมเห็น"
  },
  "url": {
    "main": {
      "parent": "URL",
      "edit": "แก้ไขการแปล URL"
    },
    "form": {
      "original": {
        "title": "ต้นฉบับใน {{language}}"
      },
      "translation": {
        "title": "การแปล URL ใน {{language}}",
        "description": "URL ที่คุณต้องการแทนที่",
        "placeholder": "แทนที่การแปล URL",
        "invalid_full": "คุณกำลังพยายามเปลี่ยนรูปแบบที่ไม่ถูกต้อง คุณควรเปลี่ยนเฉพาะสลัก/ส่วนเส้นทางของการแปล URL",
        "invalid": "URL/เส้นทางที่ให้มาไม่ถูกต้อง"
      }
    }
  },
  "urls": {
    "title": "การจัดการ URL",
    "description": "แสดงรายการและแก้ไขเนื้อหาที่แปลของ URL เว็บไซต์ทั้งหมด (ขั้นสูง ระวังข้อผิดพลาด 404)",
    "filter_languages": "กรองตามภาษา...",
    "filter_original": "กรองข้อความในภาษาต้นฉบับ",
    "filter_translation": "กรองตามข้อความที่แปล",
    "table": {
      "original": "ต้นฉบับ",
      "language": "ภาษา",
      "url": "URL ที่แปล",
      "action": "การกระทำ",
      "edited": "การแปลต้นฉบับได้ถูกแก้ไข"
    }
  }
}
